type CplatResponseShape = {
  code?: string;
  message?: string;
  data?: unknown[];
};

export type KakaoPayResponseInfo = {
  [key: string]: unknown;
  nextRedirectPcUrl?: string;
  nextRedirectMobileUrl?: string;
  nextRedirectAppUrl?: string;
  NextRedirectPcUrl?: string;
  NextRedirectMobileUrl?: string;
  NextRedirectAppUrl?: string;
};

export type KakaoPayReadyInfo = {
  kakaoPayRequestInfo: unknown;
  kakaoPayResponseInfo: KakaoPayResponseInfo;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const getCplatBody = (response: unknown): CplatResponseShape | undefined => {
  if (!isRecord(response)) return undefined;
  const body = response.data;
  if (!isRecord(body)) return undefined;

  return {
    code: typeof body.code === 'string' ? body.code : undefined,
    message: typeof body.message === 'string' ? body.message : undefined,
    data: Array.isArray(body.data) ? body.data : undefined,
  };
};

export const getCplatCode = (response: unknown) => getCplatBody(response)?.code;

export const getCplatMessage = (response: unknown) => getCplatBody(response)?.message;

export const getKakaoPayReadyInfo = (response: unknown): KakaoPayReadyInfo | undefined => {
  const firstData = getCplatBody(response)?.data?.[0];
  if (!isRecord(firstData)) return undefined;

  const requestInfo = firstData.kakaoPayRequestInfo ?? firstData.KakaoPayRequestInfo;
  const responseInfo = firstData.kakaoPayResponseInfo ?? firstData.KakaoPayResponseInfo;
  if (!isRecord(requestInfo)) return undefined;
  if (!isRecord(responseInfo)) return undefined;

  return {
    kakaoPayRequestInfo: requestInfo,
    kakaoPayResponseInfo: responseInfo,
  };
};

export const getKakaoPayMobileRedirectUrl = (responseInfo: KakaoPayResponseInfo) => {
  const redirectUrl =
    responseInfo.nextRedirectMobileUrl ??
    responseInfo.NextRedirectMobileUrl ??
    responseInfo.nextRedirectPcUrl ??
    responseInfo.NextRedirectPcUrl;

  return typeof redirectUrl === 'string' ? redirectUrl : undefined;
};
